import React, { useContext, useCallback, useMemo } from "react";
import _ from "lodash";
import { BreakpointTrackerContext } from "@jutro/layout";
import { WizardPage, wizardProps } from "@xengage/gw-portals-wizard-react";
import { ViewModelForm, withViewModelService } from "@xengage/gw-portals-viewmodel-react";
import { useValidation } from "@xengage/gw-portals-validation-react";
import { readViewModelValue } from "@xengage/gw-jutro-adapters-react";
import { EntityUtil } from '@xengage/gw-portals-util-js';
import { PremierConstants } from "premier-constant-service";
import { useUpdateSubmissionServices, validationUtil } from "premier-capability-hooks";
import metadata from "./PropertyInStoragePage.metadata.json5";
import styles from "../../SpecialtyPersonalStyles.module.scss"
import PropertyInStorageDetails from "../../components/PropertyInStorage/PropertyInStorageDetails/PropertyInStorageDetails";


function PropertyInStoragePage(props) {
  const {
    wizardData: submissionVM,
    updateWizardData,
    viewModelService
  } = props;
  const breakpoint = useContext(BreakpointTrackerContext);
  const { onValidate, initialValidation } = useValidation(
    "PropertyInStoragePage"
  );
  const { updateSubmission } = useUpdateSubmissionServices();
  const { lineName } = PremierConstants;

  const onNext = useCallback(async () => {
    const productCode = _.get(submissionVM.value, "baseData.productCode");
    // eslint-disable-next-line security/detect-object-injection
    const lobLineName = productCode ? lineName[productCode] : "";
    const response = await updateSubmission(
      lobLineName,
      "PropertyInStoragePage",
      submissionVM
    );

    submissionVM.value = response;

    return submissionVM;
  }, [lineName, submissionVM, updateSubmission]);

  const addPropertyInStorage = useCallback(async () => {

    const propertyInStorageObj = {
      tempID: EntityUtil.nextId(),
      propertyDetails: {
        isValidationReq: true,
        locRisk: {}
      },
      facilityCons: {
        isValidationReq: true,
        distoFirHydFie: 'Wit300m',
        distoFirHalFie: 'Wit8km',
        proClaFie: 'Pro'
      }
    };

    const { _xCenter, _dtoName } = submissionVM.lobData.perLine.coverables.propertyStorageCoverable.propertyInStorage;

    const propertyInStorageVM = viewModelService.create(propertyInStorageObj, _xCenter, _dtoName);

    submissionVM.lobData.perLine.coverables.propertyStorageCoverable.propertyInStorage.value = submissionVM.lobData.perLine.coverables.propertyStorageCoverable.propertyInStorage.value || []


    submissionVM.lobData.perLine.coverables.propertyStorageCoverable.propertyInStorage.pushElement(
      propertyInStorageVM
    );

    updateWizardData(submissionVM);
  },
    [submissionVM, viewModelService, updateWizardData]
  );

  const propertyInStorageOverrides = useMemo(() => {
    const propertyInStorageArray = _.get(submissionVM, 'lobData.perLine.coverables.propertyStorageCoverable.propertyInStorage', []);
    let overrides = [];

    if (!_.isEmpty(propertyInStorageArray.value)) {
      overrides = propertyInStorageArray?.children.map((propertyInStorage, index) => ({
        [`propertyInStorageDetailsComponent${index}`]: {
          overrideProps: {
            "@field": {
              // apply to all fields
              showRequired: true,
              labelPosition: "left",
            },
          },
          submissionVM,
          updateWizardData,
          pathUpdated: `lobData.perLine.coverables.propertyStorageCoverable.propertyInStorage.children[${index}]`,
        }
      }));
    }

    return Object.assign({}, ...overrides);
  }, [submissionVM, updateWizardData]);


  const onSave = useCallback(
    async () => {
      const subVMCopy = _.clone(submissionVM)
      const productCode = _.get(subVMCopy.value, 'baseData.productCode');

      validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.perLine.coverables.propertyStorageCoverable.propertyInStorage.value, ' ')

      const lobLineName = productCode ? lineName[productCode] : '';
      await updateSubmission(lobLineName, 'PropertyInStoragePage', subVMCopy);
                      
      return submissionVM;
    },
    [lineName, submissionVM, updateSubmission]
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const overrideProps = {
    "@field": {
      showRequired: true,
      labelPosition: breakpoint === "desktop" ? "left" : "top",
    },
    ...propertyInStorageOverrides,
  };

  const resolvers = {
    resolveCallbackMap: {
      onValidate,
      addPropertyInStorage,
    },
    resolveComponentMap: {
      propertyInStorageDetailsComponent: PropertyInStorageDetails
    },
    resolveClassNameMap: styles
  };

  const readValue = useCallback(
    (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
    [submissionVM, overrideProps]
  );

  const isDisableNext = () =>
    !submissionVM.lobData.perLine.coverables.propertyStorageCoverable.propertyInStorage
      .aspects.subtreeValid;

  return (
    <WizardPage
      onNext={onNext}
      onSave={onSave}
      skipWhen={initialValidation}
      disableNext={isDisableNext()}
    >
      <ViewModelForm
        uiProps={metadata.pageContent}
        model={submissionVM}
        onModelChange={updateWizardData}
        overrideProps={overrideProps}
        onValidationChange={onValidate}
        resolveValue={readValue}
        callbackMap={resolvers.resolveCallbackMap}
        componentMap={resolvers.resolveComponentMap}
        classNameMap={resolvers.resolveClassNameMap}
      />
    </WizardPage>
  );
}

PropertyInStoragePage.propTypes = wizardProps;
export default withViewModelService(PropertyInStoragePage);

